import { Modal } from 'antd';
import { useT } from '../../../locales';

interface DeleteExcepcionConfirmModalProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
}

export function DeleteExcepcionConfirmModal({
  open,
  onConfirm,
  onCancel,
  loading,
}: DeleteExcepcionConfirmModalProps) {
  const t = useT();
  return (
    <Modal
      title={t('pages.excepciones.deleteTitle')}
      open={open}
      onOk={onConfirm}
      onCancel={onCancel}
      confirmLoading={loading}
      okText={t('common.delete')}
      okButtonProps={{ danger: true }}
    >
      <p>{t('pages.excepciones.deleteConfirm')}</p>
    </Modal>
  );
}
